'use strict'
var media = angular.module('mediaModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap',
	'ui.tinymce',
	'thatisuday.dropzone'	
]);

require('./library/js/directive/libraryDirective.js')(media);
require('./library/js/libraryController.js')(media);
require('./new-media/js/directive/newMediaDirective.js')(media);
require('./new-media/js/newMediaController.js')(media);
require('./library/js/directive/mediaEditModalDirective.js')(media);
require('./library/js/directive/mediaEditDirective.js')(media);
require('./library/js/directive/attachToPostDirective.js')(media);
require('./library/js/directive/uploadApprovalRestrictionsDirective.js')(media);
require('./lazyLoadingDirective.js')(media);
require('./relatedGalleries/js/directive/relatedGalleriesDirective.js')(media);
require('./relatedGalleries/js/relatedGalleriesController.js')(media);



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/mediaModule.js
// module id = 520
// module chunks = 0